<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_fty_isDefault') || '是否默认工厂'"
            ><br />
            <el-radio-group size="small" v-model="formData.isDefault">
              <el-radio label="Y">
                {{ this.$l('INDEX.YES') || '是' }}
              </el-radio>
              <el-radio label="N">
                {{ this.$l('INDEX.NO') || '否' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_fty_scm') || '工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :selectedLabel.sync="formData.scmName"
              clearable
              filterable
              size="mini"
              style="width:100%"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_fty_scm') || '请选择工厂'
              "
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_fty_ncNo') || 'NC产品编号'"
            prop="ncNo"
          >
            <el-input v-model="formData.ncNo" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_fty_price') || '工厂单价'"
            prop="ftyPrice"
          >
            <el-input-number
              v-model="formData.ftyPrice"
              controls-position="right"
              :step="1"
              :min="0"
              :max="999999999999999"
              :precision="3"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_label_currencyUnit') || '货币单位'"
            prop="ftyPriceCurrencyUnit"
          >
            <dict-select
              v-model="formData.ftyPriceCurrencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="
                $l('INDEX.form_placeholder_currencyUnit') || '请选择货币单位'
              "
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_evg_sku_fty_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.buyerName"
              clearable
              filterable
              size="mini"
              style="width:100%"
              :placeholder="
                $l('INDEX.form_placeholder_evg_sku_fty_buyer') ||
                  '请选择采购人员'
              "
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.form_label_evg_sku_fty_lead_time') || '生产周期(天)'
            "
            prop="ftyLeadTime"
          >
            <el-input-number
              v-model="formData.ftyLeadTime"
              controls-position="right"
              :step="1"
              :min="0"
              :max="999999999"
              :precision="0"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    evgSkuCode: String,
    evgSkuFtyCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: { isDefault: 'N', ftyPriceCurrencyUnit: 'CNY' },
      rules: {
        ftyPrice: [
          {
            required: true,
            message:
              this.$l('INDEX.rule_evg_sku_fty_ftyPrice') || '请输入工厂单价',
            trigger: ' blur',
          },
        ],
        ftyPriceCurrencyUnit: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_currencyUnit') || '请选择货币单位',
            trigger: ' blur',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.rule_evg_sku_fty_scm') || '请选择工厂',
            trigger: ' blur',
          },
        ],
        buyerCode: [
          {
            required: true,
            message:
              this.$l('INDEX.rule_evg_sku_fty_buyer') || '请选择采购人员',
            trigger: ' blur',
          },
        ],
        ncNo: [
          {
            required: true,
            message:
              this.$l('INDEX.rule_evg_sku_fty_ncNo') || '请输入NC产品编号',
            trigger: ' blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.evgSkuFtyCode) return

      this.$api
        .ecomEvgSkuFtyDetailApi({
          evgSkuFtyCode: this.evgSkuFtyCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      //清除前后空格
      if (this.formData.ncNo) {
        this.formData.ncNo = this.formData.ncNo.trim()
      }
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .ecomEvgSkuFtySaveApi({
          evgSkuCode: this.evgSkuCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('saveReload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_evg_sku_fty_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_evg_sku_fty_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_evg_sku_fty_save') || '保存',
          cancelButtonText:
            this.$l('INDEX.btn_evg_sku_fty_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
